import React, { useEffect, useState } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

const SelectAssign = (props) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (typeof props.options.then !== "function") {
      setOptions(props.options);
    } else props.options?.then((op) => setOptions(op));
  }, []);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      borderBottom: "none",
      color: state.isSelected ? "#666C6C" : "null",
      background: state.isSelected ? "null" : "null",
      fontSize: state.isSelected ? "1rem" : "1rem",
      padding: 5,
      "&:hover": {
        background: state.isFocused ? "#006666" : "#fff",
        color: state.isSelected ? "#666C6C" : "#fff",
      },
    }),

    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";

      return { ...provided, opacity, transition };
    },
  };

  return (
    <CreatableSelect
      onChange={(e) => props.onChange(e)}
      isClearable
      getOptionLabel={(e) => e.firstName + " " + e.lastName}
      getOptionValue={(e) => e.id}
      value={props.value}
      options={options}
      styles={customStyles}
    />
  );
};

export default SelectAssign;
